import { render, staticRenderFns } from "./shippingLeft.vue?vue&type=template&id=0bab348b"
import script from "./shippingLeft.vue?vue&type=script&lang=js"
export * from "./shippingLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports